<template>
  <router-view />
</template>

<script>

export default {
  name: 'PaymentWrapper'
}
</script>
